import { useInstance } from '../support/ioc/useInstance';
import { IonButton, IonCard } from '@ionic/react';
import { usePageView } from '../support/tracking/usePageView.tsx';
import { Page } from '../components/page/Page.tsx';
import { AffiliateLinkState } from './AffiliateLinkState.ts';
import { HistoryViewModel } from '../app/HistoryViewModel.ts';

export const MarketplacePage: React.FC = () => {
    // TODO: event name
    usePageView('Marketplace');
    const history = useInstance(HistoryViewModel);
    const affiliateLinkState = useInstance(AffiliateLinkState);
    const affiliates = useInstance(AffiliateLinkState).getAffiliateLinks();

    return (
        <Page title="Pilot Perks" onBack={() => history.back('/')}>
            {affiliates.map((a, i) => (
                <IonCard key={`affiliate-${i}`}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 10,  }}>
                        <img height={200} src={a.heroImageUrl} style={{ borderRadius: 5 }}  />
                        <IonButton
                            fill="outline"
                            onClick={() => affiliateLinkState.affiliateLinkClicked(a, { source: 'marketplace' })}
                        >{a.offer}</IonButton>
                    </div>
                </IonCard>
            ))}
        </Page>
    );
};
